import React, {Component} from 'react';
import {inject} from 'mobx-react';
import './Password.css';

@inject ('commonStore')
export default class Password extends Component {
  render () {
    const {commonStore} = this.props;
    const passwordStyle = {
      border: 'none',
      textAlign: 'right',
      readOnly: 'true'
    };
    
    return (
      <div className="Password">
        <div className="label" >
          {this.props.label}
        </div>
        <div className="value">
          {' '} {' '}
          {!!commonStore.dealer &&
            <input
              type="password"
              value="{this.props.value}"
              style={passwordStyle}
              maxLength="2"
            />}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Profile/Password/Password.js